import { AdvancedSelect } from '@orobix/orobix-fe-components'
import i18n from 'i18next'

import { FilterButton } from '../../../components/FilterButton/FilterButton'
import { FilteringValue } from '../../../types/filtering'

type BooleanOption = { label: string; value: 'true' | 'false' }

type FilterByBooleanProps = {
  /** Used to derive a unique select id/name, e.g. the column key. */
  id: string
  filter: FilteringValue
  onFilter: (value: FilteringValue) => void
  trueLabel: string
  falseLabel: string
}

// A two-option (true/false) select filter, following the same
// FilterButton + AdvancedSelect pattern as
// `OptimizationProcesses/OptimizationProcessesList/FilterByStatus.tsx`, but
// generic over the two option labels so it can back both `machinable` and
// `manualOverride` (origin).
export const FilterByBoolean = ({
  id,
  filter,
  onFilter,
  trueLabel,
  falseLabel,
}: FilterByBooleanProps) => {
  const options: BooleanOption[] = [
    { label: trueLabel, value: 'true' },
    { label: falseLabel, value: 'false' },
  ]
  const selected = options.find((o) => o.value === filter)

  return (
    <FilterButton
      filter={filter}
      onFilter={onFilter}
      renderFilter={() => (
        <AdvancedSelect
          name={id}
          id={id}
          value={selected}
          options={options}
          onChange={(option) => onFilter(option?.value)}
          isClearable
          placeholder={<>{i18n.t('Filter...')}</>}
        />
      )}
    />
  )
}
